import type {
  ComponentValueResponse,
  RiskAssessmentInput,
  SaveComponentValueResponse,
  SnapshotInvalidation,
  SubmitInstanceRiskAssessmentRequest,
  SubmitInstanceRiskAssessmentResponse,
} from "@repo/shared/types";
import { getWithToken, postWithToken } from "../_client";

const BASE = "/public/flow/risk-assessment";

export function getPublicRiskAssessmentValue(token: string, goalId: string) {
  return getWithToken<ComponentValueResponse>(`${BASE}/${goalId}/flow-instance-value`, token);
}

export function savePublicRiskAssessmentPartial(
  token: string,
  goalId: string,
  input: RiskAssessmentInput,
) {
  return postWithToken<SaveComponentValueResponse>(
    `${BASE}/${goalId}/partial`,
    token,
    input satisfies RiskAssessmentInput,
  );
}

export function submitPublicRiskAssessment(
  token: string,
  goalId: string,
  data: RiskAssessmentInput & { score: number },
  lang?: string,
) {
  return postWithToken<SaveComponentValueResponse & { refreshHints?: SnapshotInvalidation[] }>(
    `${BASE}/${goalId}/submit`,
    token,
    { ...data, lang },
  );
}

// ─── Instance-level (client-level) capture — QL-212 ──────────────────────────
//
// No goal id in the path: these address the flow instance's own row, the one
// holding the answers the risk model captures once per client. The instance is
// identified by the session token, so there is nothing else to pass.

export function getPublicInstanceRiskAssessmentValue(token: string) {
  return getWithToken<ComponentValueResponse>(`${BASE}/flow-instance-value`, token);
}

export function savePublicInstanceRiskAssessmentPartial(token: string, input: RiskAssessmentInput) {
  return postWithToken<SaveComponentValueResponse>(
    `${BASE}/partial`,
    token,
    input satisfies RiskAssessmentInput,
  );
}

export function submitPublicInstanceRiskAssessment(
  token: string,
  data: SubmitInstanceRiskAssessmentRequest,
  lang?: string,
) {
  return postWithToken<SubmitInstanceRiskAssessmentResponse>(`${BASE}/submit`, token, {
    ...(data satisfies SubmitInstanceRiskAssessmentRequest),
    lang,
  });
}
